import { Stack } from '@koob/margaret';
import KoobButton from './KoobButton';
import KoobModal from './KoobModal';
import { useTranslation } from 'react-i18next';

interface KoobConfirmationModalProps {
  open: any;
  setOpen: any;
  title: any;
  description?: any;
  onConfirm: any;
  danger?: boolean;
  confirmLabel?: any;
  cancelLabel?: any;
  children?: any;
}

export default function KoobConfirmationModal({
  open,
  setOpen,
  title,
  description,
  onConfirm,
  danger = false,
  confirmLabel,
  cancelLabel,
  children,
}: KoobConfirmationModalProps) {
  const { t } = useTranslation('misc');
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <KoobModal open={open} setOpen={setOpen}>
      <Stack size="full" alignX="space-between" alignY="center">
        <div className="flex items-center gap-3">
          <i
            className={`fa-sharp fa-light fa-circle-exclamation text-2xl ${danger ? 'text-red-500' : 'text-gray-500'}`}
          />
          <h2
            className={`text-xl font-semibold ${danger ? 'text-red-500' : 'text-gray-500'}`}
          >
            {title}
          </h2>
        </div>

        <KoobButton variant="ghost" size="sm" onClick={handleClose}>
          <i className="fa-regular fa-circle-x text-2xl text-gray-500" />
        </KoobButton>
      </Stack>

      <div className="p-6">
        {description && <p>{description}</p>}
        {children}
      </div>

      <Stack size="full" gutterSize={1} alignX="space-between">
        <KoobButton color="secondary" onClick={handleClose} block>
          {cancelLabel || t('cancel')}
        </KoobButton>

        {onConfirm && (
          <KoobButton
            onClick={() => onConfirm()}
            block
            color="primary"
            testId="confirm-button"
          >
            {confirmLabel || t('confirm')}
          </KoobButton>
        )}
      </Stack>
    </KoobModal>
  );
}
